import { useEffect, useState } from 'react';

import type { SideNavigationScope } from './ScopeOrbit';

// Pages under different route roots render their own layout, so the switch
// remounts while the scope stays the same. The scope it last showed outlives the
// remount, so only an actual change of scope draws the orbit in.
let lastShownScope: SideNavigationScope | null = null;

export const useSettledScope = (current: SideNavigationScope): SideNavigationScope | null => {
    const [settledScope, setSettledScope] = useState(() => (lastShownScope === current ? current : null));

    if (settledScope !== null && settledScope !== current) {
        setSettledScope(null);
    }

    useEffect(() => {
        lastShownScope = current;
    }, [current]);

    return settledScope;
};
